import script from "./ConferenceActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConferenceActions.vue?vue&type=script&setup=true&lang=ts"

import "./ConferenceActions.vue?vue&type=style&index=0&id=443894eb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-443894eb"]])

export default __exports__